const compareStoredColumns = (componentColumn, storeColumn) => {
  if (storeColumn && storeColumn.length) {
    let totalEqual = 0
    for (const [key, value] of Object.entries(storeColumn)) {
        if (componentColumn[key].name === value.name) {
            totalEqual++
        }
    }
    if (storeColumn.length === totalEqual) {
      return true
    }
  } else return false
}

export default compareStoredColumns
